<template>
  <div id="dialogComparisonSelected">

    <md-dialog class="comparison" :md-active.sync="showDialogLocal" v-if="Object.keys(parametrsProducts).length>0">
      <div>
        <button class="md-primary closeDialogComparison" @click="closeDialog()" style="float:right">x</button>

        <button class="btn" style="background: no-repeat; border: 1px solid #C1C1C1;margin-right: 15px; cursor: pointer;"
          v-if="Object.keys(parametrsProducts).length>0" @click="generateReport()">
            <img src="../../assets/pdf2.svg" width="50"/>
        </button>

      </div>
      <div style="padding: 10px;  max-height: 85%;  overflow-y: auto; min-height:500px; min-width:650px;">

      <h4 style="padding: 0px;  margin: 0px 18px;" v-if="Object.keys(parametrsProducts).length>0">{{ $t("porownywane_produkty") }}</h4>
        <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="false"
        :preview-modal="false"
        :paginate-elements-by-height="1300"
        :filename="file_name"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a3"
        pdf-orientation="landscape"
        pdf-content-width="100%"

        @progress="onProgress($event)"
        @beforeDownload="beforeDownload($event)"
        @hasDownloaded="hasDownloaded($event)"
        ref="html2Pdf"
      >

        <section slot="pdf-content">
          <!-- {{ this.$i18n.locale }}
          {{ $i18n.locale }} -->
          <!-- <section class="pdf-item"> -->
            <table v-if="Object.keys(parametrsProducts).length>0" class="tabComparison">

              <tr>
                <th style="width: 18%;"></th>
                <th :style="'width:'+(82/Object.keys(comparisonList).length)+'%'" v-for="comparison in comparisonList" :key="comparison">
                  {{comparison}}
                </th>
              </tr>
              <tr>
                <td></td>
                <td v-for="compImg, indexCompImg in comparisonList" :key="indexCompImg" style="text-align: center;">
                  <img v-if="compImg" v-lazy="$url_img(compImg)" class="pic" style="max-height: 60px;"/>
                </td>
              </tr>
              <tr v-for="param,indexParam in parametrsProducts.attributes" :key="indexParam" :class="diffrentColumns(indexParam)">
                <td>{{param}}</td>
                <td v-for="comp, indexComp in comparisonList" :key="indexComp">
                  <template v-if="parametrsProducts.data[indexComp] && parametrsProducts.data[indexComp] && parametrsProducts.data[indexComp][indexParam]">
                    <div v-html="parametrsProducts.data[indexComp][indexParam].desc">
                    </div>
                  </template>
                  <template v-else >
                    <div style="text-align: center;">
                      -
                    </div>
                  </template>
                </td>
              </tr>

            </table>
            <!-- </section> -->
          </section>
        </vue-html2pdf>

      </div>
    </md-dialog>


  </div>
</template>

<script>

import { helpers } from "../../mixins/helpers"
import { auth } from '../../mixins/auth'
import { mapGetters } from "vuex"
import VueHtml2pdf from 'vue-html2pdf'

export default {
  name: "dialogComparisonView",
  mixins: [auth, helpers],
  props: ['showDialog'],
  data() {
    return {
      file_name: 'comparison-' + new Date().toLocaleDateString(),
      showDialogLocal: false,
      url: "https://www.google.com"
    };
  },
  components: {VueHtml2pdf},
  computed: {
    ...mapGetters('products', ["comparisonList","parametrsProducts"]),
    clearComparionList () {
      // this.$store.commit('products/SET_COMPARISON_PARAMETRS', [])
    },
    aaa () {
      return "https://www.pulsar.pl/PL_9999_AWO000_searching";
    }
  },
  watch: {
    showDialog (newValue ) {
      if (newValue) {
        this.showDialogLocal = true
      }
    }
  },
  methods: {
    clickUrl () {
      console.log('dupa')
      this.window.location.href = "https://www.pulsar.pl/PL_9999_AWO000_searching";
    },
    diffrentColumns  (item) {
      var strClass = ''
      if (this.parametrsProducts.diffrentRows[item] === 'rozne') {
        strClass = 'strcmp'
      }
      return strClass
    },
    $url_img(elem) {

      // const toDataUrl = function (url, callback) {
      //   //Convert to base64
      //   return new Promise((resolve, reject) => {
      //     var xhr = new XMLHttpRequest();
      //     xhr.onload = function () {
      //       var reader = new FileReader();
      //       reader.onloadend = function () {
      //         resolve(reader.result);
      //       };
      //       reader.readAsDataURL(xhr.response);
      //     };
      //     xhr.onerror = () => {
      //       reject({
      //         status: this.status,
      //         statusText: xhr.statusText,
      //       });
      //     };
      //     xhr.open("GET", url);
      //     xhr.responseType = "blob";
      //     xhr.send();
      //   });
      // };
      let prod = this.slash_to_comma(elem)
      // let urlBase64 = toDataUrl(process.env.VUE_APP_ROOT_IMG + prod + "_1.png")
      // return urlBase64

      //let prod = (elem.indexOf('/'))?elem.replace('/',','):elem;
      return process.env.VUE_APP_ROOT_IMG + prod + "_1.png"
    },
    closeDialog () {
      // console.log('closeDialog')
      this.showDialogLocal = false
      this.$store.dispatch('products/get_data_values',[])
      this.$emit('clickDialogComparison', false)
    },
    generateReport () {
      this.$refs.html2Pdf.generatePdf()
    },
    async beforeDownload ({ html2pdf, options, pdfContent }) {
      await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages()
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i)
          pdf.setFontSize(5)
          pdf.setTextColor(120)
          pdf.text(i + ' / ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
        }
        // this.$store.commit('app/SET_LOADING', !this.loading, { root: true })
      }).save()
    },
    onProgress ({ html2pdf, options, pdfContent }) {
      // this.$store.commit('app/SET_LOADING', !this.loading, { root: true })
    },
    hasDownloaded ({ html2pdf, options, pdfContent }) {
      // console.log('hasDownloaded')
    }
  }
}

</script>

<style scoped>
.tabComparison .strcmp {
  background: #ffe9e9;
}
div.md-dialog.comparison div.md-dialog-container.md-dialog-fullscreen.md-theme-default {
  width: 100%;
  height: 100%;
}
.closeDialogComparison{
  color: red !important;
  background: #ffd3d3;
  width: 32px;
  height: 30px;
  font-size: 18px;
  border: none;
  margin: 5px;
  cursor: pointer;
}
.closeDialogComparison:hover {
  color: white !important;
  background: red;
}

.md-manual {
  min-width: 88px !important;
  height: 30px !important;
  margin: 0 !important;
  width: 50px;
  position: absolute !important;
  right: 0;
  bottom: 0;
  color: #337ab7;
  border: none;
  cursor: pointer;
  background: #e6f2fd;
}
.md-manual:hover {
  background:  #337ab7;
  color: white;
}


.vue-html2pdf {
  overflow: auto;
  overflow-x: hidden;
}
section.pdf-item {
  margin-bottom: 0px;
  padding: 15px;
}

.table tr {
  /* line-height: 8px; */
}
.table tr td{
  /* line-height: 12px; */
}

.table tr:nth-child(even) {background: #FFF}
.table tr:nth-child(odd) {background: #FFF}

.table thead th {
font-size: 12px;
line-height: 12px;
}
.col-sm {
  text-align: center;
  padding: 0px;
}
.col-sm h5 {
  text-align: center;
}
.md-avatar[data-v-1b4e33f8] {
    width: 0px;
    min-width: 20px;
    height: 28px;
    border-radius: 0px;
    margin-left: 34px;
    margin-right: 10px;
}

.md-dialog-container {
  width: 100%;
  background: white;
}
#content-more table th {
  display: table-cell;
  vertical-align: middle;
}
#content-more h4 {
  font-size: 16px; font-weight: bold;
}
#content-more p {
  margin: 0px 0px;
}
#content-more p ul{
  /* display: inline-flex; */
  margin-left: 0px;
  padding-left: 0px;
}
#content-more .list-group-item{
  padding: 5px 10px !important;
  margin-bottom: 0px;
}
#content-more p .list-group-item{
  padding: 5px 10px !important;
  margin-bottom: 0px;
}
#content-more p table{
  font-size: 11px;
}

#content-main table {
padding: 0px 5px;
}
div#content-main table tr {
  padding: 0px 15px;
}
div#content-main table th {
  width: 150px;
  border-top: 0px solid #ddd;
}
div#content-main table tr.list-group-item td {
  border-top: 0px solid #ddd;
}
</style>




// WEBPACK FOOTER //
// src/components/Dialogs/DialogComparisonView.vue